import React, { useState, useEffect, useRef } from "react";

import fondJeu from "assets/puzzles/iserba/roadSafety/interieur_voiture_garage.svg";
import boiteBiscuit from "assets/puzzles/iserba/roadSafety/boite_biscuits.svg";
import telephone from "assets/puzzles/iserba/roadSafety/telephone.svg";
import telephone_bg from "assets/puzzles/iserba/roadSafety/telephone_bg.svg";
import telephone_avec_icones from "assets/puzzles/iserba/roadSafety/telephone_avec_icones.svg";
import bluetooth from "assets/puzzles/iserba/roadSafety/bluetooth.svg";
import bluetoothDesactive from "assets/puzzles/iserba/roadSafety/bluetooth_desactive.svg";
import cle from "assets/puzzles/iserba/roadSafety/cle.svg";
import interfaceGpsActive from "assets/puzzles/iserba/roadSafety/interface_gps_active.svg";
import interfaceGps from "assets/puzzles/iserba/roadSafety/interface_gps_inactive.svg";
import sac from "assets/puzzles/iserba/roadSafety/sac.svg";
import TypewriterText from "components/shared/TypeWriterText";

const GRID_SIZE = 5;

const _question = {
	options: [
		{
			value: "barre-proteinée",
			isCorrect: true,
			position: [4, 3],
			hint: "Manger en conduisant ? Mauvais plan… Une seconde d'inattention, et ça peut mal finir. Allez, je range ça.",
			brokenImg: boiteBiscuit,
			fixedImg: null,
			action: "remove",
		},
		{
			value: "telephone",
			isCorrect: true,
			position: [4, 2],
			hint: "",
			brokenImg: telephone_avec_icones,
			fixedImg: telephone,
			action: "openPhone",
		},
		{
			value: "sac",
			isCorrect: true,
			position: [3, 3],
			hint: "Si ça bouge et que ça tombe, ça peut me déconcentrer… Allez, mieux vaut le mettre dans le coffre.",
			brokenImg: sac,
			fixedImg: null,
			action: "remove",
			relativeTo: "background",
			top: "57%",
			left: "60%",
			height: "25%",
			width: "25%",
		},
		{
			value: "calibration-gps",
			isCorrect: true,
			position: [2, 2],
			hint: "Rue du Chat Botté ! Ça va aller, le client ne me semble pas très loin.",
			brokenImg: interfaceGps,
			fixedImg: interfaceGpsActive,
			action: "calibrateGPS",
			relativeTo: "background",
			top: 0,
			left: 0,
			height: "100%",
			width: "100%",
		},
	],
};

const IserbaGame1ClickPuzzle2 = ({ question, onAnswer }) => {
	const [grid, setGrid] = useState(
		Array(GRID_SIZE)
			.fill(null)
			.map(() => Array(GRID_SIZE).fill(null))
	);
	const gridRef = useRef(null);
	const [gridSize, setGridSize] = useState(0);
	const [hint, setHint] = useState({
		text: "Mince ! Je vais avoir du retard… Bon, au moins je crois connaître le chemin jusqu'au prochain client !",
		onClickFinish: () => {
			setHint(null);
		},
	});
	const [phoneOpened, setPhoneOpened] = useState(false);
	const [bluetoothConnected, setBluetoothConnected] = useState(false);
	const [callMade, setCallMade] = useState(false);

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	useEffect(() => {
		setGrid((prevGrid) => {
			const newGrid = prevGrid.map((row) => [...row]);
			_question.options.forEach(({ position, brokenImg, fixedImg }) => {
				const [x, y] = position;
				newGrid[x][y] = { fixed: false, brokenImg, fixedImg };
			});
			return newGrid;
		});
	}, []);

	const toggleCell = (x, y) => {
		_question.options.forEach((option) => {
			if (option.position[0] === x && option.position[1] === y) {
				if (option.action === "openPhone") {
					setPhoneOpened(true);
				} else if (!grid[x][y]?.fixed) {
					setGrid((prevGrid) => {
						const newGrid = prevGrid.map((row) => [...row]);
						newGrid[x][y].fixed = true;
						return newGrid;
					});
					setHint({
						text: option.hint,
						onClickFinish: () => {
							setHint(null);
						},
					});
				}
			}
		});
	};

	const handlePhoneInteraction = (action) => {
		if (action === "connectBluetooth") {
			setBluetoothConnected((prev) => !prev);
		} else if (action === "callClient" && !callMade) {
			setCallMade(true);
			setHint({
				text: "Technicien : Bonjour ! Excusez-moi, mon dernier chantier a pris du retard. J’arriverai avec 10 minutes de décalage par rapport à l'horaire prévu.",
				onClickFinish: () => {
					setHint({
						text: "Client : Merci de m'avoir prévenu, roulez prudemment !",
						onClickFinish: () => {
							setHint(null);
						},
					});
				},
			});
		}
	};

	useEffect(() => {
		if (callMade && bluetoothConnected) {
			_question.options
				.filter(({ action }) => action === "openPhone")
				.forEach((option) => {
					const [x, y] = option.position;
					setGrid((prevGrid) => {
						const newGrid = prevGrid.map((row) => [...row]);
						newGrid[x][y].fixed = true;
						return newGrid;
					});
				});
		}
	}, [callMade, bluetoothConnected]);

	const submitAnswer = () => {
		const errors = [];

		_question.options.forEach(({ position, action, value }) => {
			const [x, y] = position;

			if (action === "openPhone") {
				if (!bluetoothConnected) {
					errors.push(`connection-bluetooth`);
				}
				if (!callMade) {
					errors.push(`appel-client`);
				}
			} else {
				if (!grid[x][y]?.fixed) {
					errors.push(value); // Store the name of the incorrect item
				}
			}
		});

		const allCorrect = errors.length === 0;

		onAnswer({
			scene_2_correct: allCorrect,
			scene_2_errors: errors,
		});
	};

	return (
		<div className="relative flex flex-col items-start non-selectable">
			<div
				ref={gridRef}
				className={`relative grid grid-cols-${GRID_SIZE} grid-rows-${GRID_SIZE} gap-0 m-auto w-full aspect-square border-black border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)] bg-black`}
				style={{
					width: gridSize,
					height: gridSize,
					backgroundImage: fondJeu ? `url(${fondJeu})` : "none",
					backgroundSize: "cover",
				}}
			>
				{grid.map((row, x) =>
					row.map((cell, y) => (
						<div
							key={`${x}-${y}`}
							onClick={() => toggleCell(x, y)}
							className="w-full h-full flex items-center  justify-center aspect-square cursor-pointer transition-all bg-transparent"
						>
							{_question.options
								.filter(({ relativeTo }) => relativeTo !== "background")
								.map(({ brokenImg, fixedImg, position }, index) => {
									if (
										position[0] === x &&
										position[1] === y &&
										(grid[x][y]?.fixed ? fixedImg : brokenImg)
									) {
										return (
											<img
												alt="Grid Element"
												key={index}
												src={grid[x][y]?.fixed ? fixedImg : brokenImg}
												className="w-full h-full object-contain pointer-events-none"
											/>
										);
									}
									return null;
								})}
						</div>
					))
				)}
				{_question.options
					.filter(({ relativeTo }) => relativeTo === "background")
					.map(
						(
							{
								value,
								brokenImg,
								fixedImg,
								position,
								width,
								height,
								top,
								left,
							},
							index
						) => {
							return (
								(!grid[position[0]][position[1]]?.fixed ||
									(grid[position[0]][position[1]]?.fixed && fixedImg)) && (
									<img
										key={index}
										src={
											grid[position[0]][position[1]]?.fixed
												? fixedImg
												: brokenImg
										}
										alt=""
										style={{
											width: width,
											height: height,
											top: top,
											left: left,
										}}
										className={`absolute top-0 left-0 w-full h-full object-contain pointer-events-none`}
									/>
								)
							);
						}
					)}

				{hint && (
					<div
						className={`absolute z-20 top-[0%] left-4 right-16 text-sm py-2 px-4 shadow-md mb-4 bg-white rounded-3xl`}
						style={{
							maxWidth: phoneOpened ? "calc(50% - 64px)" : "calc(100% - 32px)",
						}}
					>
						<TypewriterText
							text={hint.text}
							onClickFinish={hint.onClickFinish}
						/>
					</div>
				)}
				{phoneOpened && (
					<div
						className="absolute top-0 right-0 flex flex-col items-center justify-center h-full w-[80%] max-w-[250px] bg-cover bg-center"
						style={{ backgroundImage: `url(${telephone_bg})` }}
					>
						<div className="p-8 rounded-lg h-3/4 text-center">
							<button
								onClick={() => handlePhoneInteraction("connectBluetooth")}
								disabled={bluetoothConnected}
								className="flex flex-col items-center justify-center text-xs mb-2 w-full h-1/2 bg-blue-500 text-white px-4 py-2 rounded-3xl disabled:opacity-50"
							>
								<img
									src={bluetoothConnected ? bluetooth : bluetoothDesactive}
									alt="bluetooth"
									className="w-6 h-8 inline-block mb-2"
								/>
								{bluetoothConnected
									? "Bluetooth Connecté ✓"
									: "Connecter Bluetooth"}
							</button>
							<button
								onClick={() => handlePhoneInteraction("callClient")}
								disabled={callMade}
								className="bg-green-500 w-full h-1/2 text-white text-xs px-4 py-2 rounded-3xl disabled:opacity-50"
							>
								{callMade ? "Appel effectué ✓" : "Appeler le client"}
							</button>
							<button
								onClick={() => setPhoneOpened(false)}
								className="mt-4 bg-black text-white px-4 py-2 rounded-full"
							>
								Fermer
							</button>
						</div>
					</div>
				)}
			</div>
			<div className="mt-4 h-24 px-4 mb-8 flex w-full justify-end items-center gap-0">
				<img
					src={cle}
					alt="cle"
					width={40}
					height={40}
					className="w-12 h-12 inline-block mr-2"
				/>
				<button
					onClick={submitAnswer}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Continuer
				</button>
			</div>
		</div>
	);
};

export default IserbaGame1ClickPuzzle2;
